<template>
  <div class="hytd_content">
    <AppNewHeader
      style="width: 100%"
      :userName="userName"
      :placeholderText="'搜索知识资源'"
    />
    <div class="hydtbanner">
      <p>聚焦动态，赋能发展</p>
    </div>
    <div class="news-columns">
      <div
        class="news-column"
        v-for="(col, colIndex) in columnData"
        :key="colIndex"
      >
        <div
          class="news-item"
          v-for="(item, itemIndex) in col"
          :key="itemIndex"
        >
          <h3 class="news-title" @click="gotodetail(item.href)">
            {{ item.noticeTitle }}
          </h3>
          <img
            v-if="item.imgUrl"
            :src="getImagePath(item.imgUrl)"
            class="news-image"
            alt="新闻图片"
          />
          <p class="news-desc" v-html="item.description"></p>
          <div class="news-footer">
            <p class="news-date">{{ formatDate(item.createTime) }}</p>
          </div>
        </div>
      </div>
    </div>

    <AppFooter />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import AppNewHeader from "@/views/components/AppNewHeader.vue";
import AppFooter from "@/views/components/AppFooter.vue";
import zfbmimg from "@/assets/newimages/zfbmimg.png";
import kydwimg from "@/assets/newimages/kydwimg.png";
import { Cookie } from "@/utils/Cookie";
import { usePageStayTime } from "@/utils/usePageStayTime";
const { stayTime, totalStayTimes } = usePageStayTime();
const userName = ref("");
const hiddenTime = ref(Number);
const weburl = ref(window.location.href);
const LoginType = ref(false);

import { getselectNotice, getBuyLog } from "@/api/index.js";

const newsList = ref([
  {
    title: "AI助出版 智启未来“AI编辑助手免费试用活动",
    description:
      "从选题策划的灵感碰撞，到稿件审校的严谨细致，再到文案撰写的创意飞扬……AI编辑助手将伴您走过出版的每一个环节，提供全方位的智能服务，让您的出版工作更加得心应手。我们诚挚邀请您参与此次免费试用活动，亲身体验AI编辑助手为您带来的便捷与高效。期间，我们特设“最佳产品设计师”“优秀产品体验官”评奖活动，让您在享受AI编辑助手智能助力的同时，也能享受额外惊喜与乐趣。",
    time: "2023-07-01",
    author: "作者1",
    image: zfbmimg,
  },
  {
    title: "2024年全国两会知识服务月",
    description:
      "在七八十年代，这种面料做成的服装非常受欢迎，它可以有十分多样的颜色，也十分耐用耐磨，这些性质让它成为那个时代的香饽饽，甚至当时的人们以拥有一件的确良衣服而感到自豪。然而，的确良的流行只在七八十年代短暂出现，之后就突然消失了一样很少出现在公众视野，而到了今天，大部分人已经忘记它存在过了。",
    time: "2023-07-02",
    author: "作者2",
    image: zfbmimg,
  },
  {
    title: "AI助出版 智启未来",
    description: "让您在享受AI编辑助手智能助力的同时，也能享受额外惊喜与乐趣。",
    time: "2023-07-03",
    author: "作者3",
    image: kydwimg,
  },
  {
    title: "41℃高温下，被抢爆的藿香正气背后！",
    description:
      "一到假期，大量“xx暑假最可怕”的视频、文章就占领各大社交媒体平台。本是无忧无虑的快乐暑假，怎么就可怕了？配上氛围紧张的背景音乐，一些所谓“资深人士”在短视频、营销号里“情真意切”地提醒家长，“暑假不规划，开学差距大”“不怕同学是学霸，就怕学霸过暑假”……视频下方的链接里显示，相关资料、课程已售出上万套。",
    time: "2023-07-04",
    author: "作者4",
    image: zfbmimg,
  },
  {
    title: "国产电车的遮羞布，被高温撕掉了",
    description: "",
    time: "2023-07-05",
    author: "作者5",
    image: zfbmimg,
  },
  {
    title: "AI助出版 智启未来“AI编辑助手免费试用活动",
    description:
      "从选题策划的灵感碰撞，到稿件审校的严谨细致，再到文案撰写的创意飞扬……AI编辑助手将伴您走过出版的每一个环节，提供全方位的智能服务，让您的出版工作更加得心应手。我们诚挚邀请您参与此次免费试用活动，亲身体验AI编辑助手为您带来的便捷与高效。期间，我们特设“最佳产品设计师”“优秀产品体验官”评奖活动，让您在享受AI编辑助手智能助力的同时，也能享受额外惊喜与乐趣。",
    time: "2023-07-06",
    author: "作者6",
  },
  {
    title: "为什么现在中端机更受欢迎？看了这几款我完全懂了",
    description:
      "那在收入增速趋势下行，消费倾向边际降低，贷款融资大幅减少，购房支出明显回落的当下，居民投资配置会产生哪些变化？分享华创证券发布的《宏观专题：居民的钱都投资去了哪里？》，报告参考日本90年代数据，对我国的居民资金流量表进行了分析。",
    time: "2023-07-07",
    author: "作者7",
    image: zfbmimg,
  },
  {
    title: "A股暴力拉升，人民币狂涨，牛市要来了吗？",
    description:
      "近日，一则“携程推出火车卧铺女性拼团功能”的消息引发关注，该服务收费标准为10元/人，称拼团成功出票时，保证同房间均为女性，拼团失败将退还费用。7月26日，12306客服工作人员告诉极目新闻记者，目前列车上暂未设置专门的女性车厢，乘客若有需求，可以向列车员寻求帮助，协调更换车厢位置。",
    time: "2023-07-08",
    author: "作者8",
    image: zfbmimg,
  },
  {
    title: "进北大每人交10800元，研学还是打劫？",
    description:
      "那在收入增速趋势下行，消费倾向边际降低，贷款融资大幅减少，购房支出明显回落的当下，居民投资配置会产生哪些变化？分享华创证券发布的《宏观专题：居民的钱都投资去了哪里？》，报告参考日本90年代数据，对我国的居民资金流量表进行了分析。",
    time: "2023-07-05",
    author: "作者5",
    image: zfbmimg,
  },
  {
    title: "同甘不共苦， “消失”的房企合伙人",
    description:
      "在核污染水处置问题上，日方应正视国际社会的合理关切，本着对全球海洋环境和公众健康负责任的态度，同包括周边邻国在内的利益攸关方开展充分、有意义的协商。日方继续强推核污染水排海，只会激起更强烈的反对。",
    time: "2023-07-05",
    author: "作者5",
  },
  {
    title: "AI助出版 智启未来",
    description: "让您在享受AI编辑助手智能助力的同时，也能享受额外惊喜与乐趣。",
    time: "2023-07-05",
    author: "作者5",
    image: zfbmimg,
  },
  {
    title: "外观惊艳、信号改善！你理想中的 iPhone，已在路上",
    description:
      "舳舻千里，旌旗蔽空，酾酒临江，横槊赋诗……在古代，水上航运是常用的交通方式。时光划过千百年，打通“黄金水道”复兴水上交通，成为时代的新命题。",
    time: "2023-07-05",
    author: "作者5",
    image: zfbmimg,
  },
]);
import dayjs from "dayjs";

const formatDate = (dateString) => {
  return dayjs(dateString).format("YYYY-MM-DD"); // 或者 'YYYY/MM/DD'
};
const getHydtList = async () => {
  const res = await getselectNotice({
    pageIndex: "1",
    pageSize: "10",
  });

  if (res.info) {
    newsList.value = res.info.list;
  }
};
const gotodetail = (href) => {
  if (href) {
    window.open(href, "_blank");
  }
};
const getImagePath = (filePath) => {
  const baseApi = process.env.VUE_APP_BASE_API;
  if (baseApi) {
    return process.env.VUE_APP_BASE_API + "/ckbop" + filePath;
  } else {
    return "/ckbop" + filePath;
  }
};

const checkTokenStatus = async () => {
  const token = JSON.parse(Cookie.get("token")) || "";
  if (token && !isTokenExpired(token)) {
    const userString = JSON.parse(Cookie.get("userInfo")) || null;
    const user = userString || null;
        userName.value = user?.realName;;
  }
};
const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp) {
      return Date.now() >= payload.exp * 1000;
    }
    return false; // 如果没有exp字段，则认为永不过期
  } catch (e) {
    return true; // 解析失败视为过期
  }
};
const handleLog = async () => {
  try {
    const res = await getBuyLog({
      type: "10",
      url: weburl.value,
      second: stayTime._value,
    });
    if (res) {
    }
  } catch (error) {
    console.log(error);
  }
};
window.addEventListener("load", async () => {
  // console.log('页面被刷新了',timestamp.value);
  const stored = localStorage.getItem("lastSelectTime");
  // console.log('当前时间戳：',Date.now());
  // const timestamp2 = ref(Number(sessionStorage.getItem('timestamp')))
  hiddenTime.value = Math.floor((Date.now() - stored) / 1000);
  try {
    const res = await getBuyLog({
      type: "10",
      url: weburl.value,
      second: hiddenTime.value,
    });
    if (res.status == 200) {
      localStorage.setItem("lastSelectTime", Date.now().toString());
    }
  } catch (error) {
    console.log(error);
  }
});
onUnmounted(async () => {
  await handleLog();
});
onMounted(async () => {
  await getHydtList();
  await checkTokenStatus();
});

const columnData = computed(() => {
  const columns = [[], [], [], []];
  newsList.value.forEach((item, index) => {
    columns[index % 4].push(item);
  });
  return columns;
});
</script>

<style scoped>
.hytd_content {
  width: 100%;
  background: #f2f2f2;
}
.hydtbanner {
  width: 100%;
  height: 200px;
  background-image: url(@/assets/newimages/hydtbanner.png);
  background-size: cover;
  /* display: flex; */
  align-items: center;
}
.hydtbanner p {
  font-size: 45px;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
  /* margin-left: 314px; */
  width: 1400px;
  margin: 0 auto;
  padding-top: 77px;
}

.news-columns {
  width: 1400px;
  margin: 40px auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  /* gap: 20px; */
  align-items: flex-start;
  background: #fff;
}

.news-column {
  display: flex;
  flex-direction: column;
  /* gap: 20px; */
  border-right: 1px solid #e5e5e5;
}

.news-column:nth-child(4n) {
  border-right: none;
}
.news-item {
  width: 100%;
  background: #fff;
  padding: 32px 24px 0 24px;
}

.news-item {
  width: 100%;
  background: #fff;
  padding: 32px 24px 0 24px;
  border-top: 1px solid #e5e5e5;
}
.news-item:first-child {
  border-top: none;
}
.news-title {
  font-size: 18px;
  font-weight: 500;
  text-align: LEFT;
  color: #333333;
}
.news-title:hover {
  cursor: pointer;
  color: #1c6bfb;
}

.news-image {
  width: 287px;
  /* height: 156px; */
  object-fit: cover;
  display: block;
  margin-top: 15px;
  transition: transform 0.5s ease;
}
.news-image:hover {
  animation: zoomInOut 1s ease;
  cursor: pointer;
}

.news-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
  word-break: break-word;
  margin-top: 24px;
  text-align: justify;
}

.news-footer {
  display: flex;
  justify-content: right;
  font-size: 12px;
  color: #999;
  margin-bottom: 32px;
}

@keyframes zoomInOut {
  0% {
    transform: scale(1); /* 初始大小 */
  }
  50% {
    transform: scale(0.9); /* 缩小到 90% */
  }
  100% {
    transform: scale(1.1); /* 放大到 110% */
  }
}
</style>
